var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { selectEventBuffByTargetId } from "../../../selectors/selectBuffsInfo";
import { selectActiveDiscountEventInfoByEventType } from "../../../selectors/selectEventInfo";
import { selectOutskirtBuildingInfo } from "../../../selectors/selectOutskirtBuildingInfo";
import { selectOutskirtBuildingUpgradeInfo, selectOutskirtBuildingUpgradeRequirementsResourceInfo, } from "../../../selectors/selectOutskirtBuildingUpgradeInfo";
import { selectPlayerLevel } from "../../../selectors/selectPlayerLevelInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { capitalize } from "../../../utils/stringUtils";
import { utilBuff } from "../../../utils/utilBuff";
import { utilCompatibility } from "../../../utils/utilCompatibility";
import { utilEvent } from "../../../utils/utilEvent";
import { EventType, } from "../../balancing/types/BalancingCore";
import { DiscountEventTimer } from "../../discount-event/DiscountEventTimer";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { ButtonSecondary } from "../../generic/common/ButtonSecondary";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionOutskirtBuildingUpgrade } from "../../info/outskirts/actionOutskirtsInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { BuildingUpgradeOld } from "../../player-base/buildings/upgrade/BuildingUpgradeOld";
import { OutskirtBuildingUpgradeMaxLevel } from "./OutskirtBuildingUpgradeMaxLevel";
import { OutskirtBuildingUpgradeNew } from "./OutskirtBuildingUpgradeNew";
import { OutskirtBuildingUpgradeRequirements } from "./OutskirtBuildingUpgradeRequirements";
var _OutskirtBuildingUpgrade = function (_a) {
    var building = _a.building, constructionTime = _a.constructionTime, currentStage = _a.currentStage, discountEvent = _a.discountEvent, goldDiscountBuff = _a.goldDiscountBuff, maxLevel = _a.maxLevel, nextStage = _a.nextStage, onInfoButtonClick = _a.onInfoButtonClick, onUpgradeResources = _a.onUpgradeResources, requirements = _a.requirements, upgradeEffects = _a.upgradeEffects, upgradeTextLoca = _a.upgradeTextLoca;
    var discountBadge = createDiscountBadge(discountEvent, goldDiscountBuff);
    var ButtonComponent = requirements.some(function (_a) {
        var id = _a.id, amount = _a.amount;
        return id === IdResource.Gold && amount.isPositive();
    })
        ? ButtonSecondary
        : ButtonPrimary;
    return (React.createElement("div", { className: "h100" }, currentStage.level === maxLevel ? (React.createElement(OutskirtBuildingUpgradeMaxLevel, { buildingName: building.balancing.name, buildingStage: currentStage })) : (React.createElement("div", { className: "outskirt-building-upgrade" },
        React.createElement("div", { className: "building-upgrade__content-wrapper" },
            React.createElement("div", { className: "building-upgrade__content" },
                React.createElement(BuildingUpgradeOld, { currentStage: currentStage, nextStage: nextStage, building: building, constructionTime: constructionTime, onInfoButton: onInfoButtonClick }),
                React.createElement(OutskirtBuildingUpgradeNew, { currentStage: currentStage, nextStage: nextStage, building: building, upgradeEffects: upgradeEffects }))),
        React.createElement(TextLoca, { id: upgradeTextLoca, className: IdStyles.TextBoldPrimary }),
        React.createElement(OutskirtBuildingUpgradeRequirements, { buildingId: building.balancing.id }),
        React.createElement("div", { className: "outskirt-building-upgrade__button" },
            React.createElement("div", { style: utilCompatibility.getMsGridPositions(0, 3) }, discountBadge),
            React.createElement(ButtonComponent, { onClick: function () { return onUpgradeResources(building); }, style: utilCompatibility.getMsGridPositions(1, 3) },
                React.createElement(TextLoca, { id: IdLoca.upgrade, className: IdStyles.TextButtonDefault })))))));
};
var createDiscountBadge = function (discountEvent, goldDiscountBuff) {
    return goldDiscountBuff && discountEvent ? (React.createElement(DiscountEventTimer, { discountAmount: utilBuff.factorMultiplicationToPercentage(goldDiscountBuff.factorMultiplication), endTime: utilEvent.getEndTime(discountEvent) })) : (React.createElement(React.Fragment, null));
};
var mapState = function (state, ownProps) {
    var building = selectOutskirtBuildingInfo(state, ownProps.type);
    building = __assign({}, building, { balancing: __assign({}, building.balancing, { name: capitalize(building.balancing.name) }) });
    var constructionTime = 0;
    var playerLevel = selectPlayerLevel(state);
    var discountEvent = selectActiveDiscountEventInfoByEventType(state, EventType.OutskirtDiscount);
    var goldDiscountBuff = discountEvent
        ? selectEventBuffByTargetId(state, discountEvent, IdResource.Gold)
        : undefined;
    return __assign({ building: building,
        constructionTime: constructionTime,
        discountEvent: discountEvent,
        goldDiscountBuff: goldDiscountBuff,
        playerLevel: playerLevel, requirements: selectOutskirtBuildingUpgradeRequirementsResourceInfo(state, building.balancing.id) }, selectOutskirtBuildingUpgradeInfo(state, ownProps.type));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: function () { return actionModalClose(IdModal.BuildingUpgrade); },
        onUpgradeResources: function (building) {
            return actionOutskirtBuildingUpgrade(building);
        },
    }, dispatch);
};
export var OutskirtBuildingUpgrade = connect(mapState, mapDispatch)(_OutskirtBuildingUpgrade);



//////////////////
// WEBPACK FOOTER
// ./src/features/outskirts/upgrade/OutskirtBuildingUpgrade.tsx
// module id = 439
// module chunks = 3